import { createSlice } from "@reduxjs/toolkit";

export const SelectedChat = createSlice({
  name: "selectedChat",
  initialState: {
    selectedChat: null,
  },
  reducers: {
    setSelectedChat: (state, action) => {
      state.selectedChat = action.payload;
    },
  },
});

export const { setSelectedChat } = SelectedChat.actions;

export default SelectedChat.reducer;
